import './match-startup-formations.scss';

import React from 'react';

import t from '../../../labels/labelling-utils';
import { makeClassNames } from '../../../utils/styles';
import Text from '../../atoms/text/text';
import { ITeam } from '../../molecules/team/team';
import { IMatchFormationField } from '../../organisms/match-formation-field/match-formation-field';
import MatchStartupFormation, {
  IMatchStartupFormation,
} from '../../organisms/match-startup-formation/match-startup-formation';
import { IMatchFormations, IMatchFormationsDataTeam } from '../match-formations/match-formations';
import { exchangeOwnGoals } from '../match-formations/match-formations-helpers';

export interface IMatchFormationsFields {
  away: IMatchFormationField;
  home: IMatchFormationField;
}

export interface IMatchStartupFormations extends IMatchFormations {
  matchFormationsFields: IMatchFormationsFields;
}

const classNames = () =>
  makeClassNames({
    MatchStartupFormations: 'match-startup-formations',
    MatchTitle: 'match-title',
  });

const getTitle = (home: ITeam, away: ITeam): string => `${home.name}–${away.name}, ${t('match.formations.title')}`;

const MatchStartupFormations = ({ matchFormations, matchFormationsFields }: IMatchStartupFormations) => {
  const cn = classNames();

  const matchLineups: IMatchFormationsDataTeam = exchangeOwnGoals(matchFormations); // This is the FIX for the AUTOGOAL scorers issue
  const { away, home, referees } = matchLineups;
  const { away: awayField, home: homeField } = matchFormationsFields;
  const teamHome: IMatchStartupFormation = {
    teamField: homeField,
    team: home,
    isHome: true,
  };
  const teamAway: IMatchStartupFormation = {
    teamField: awayField,
    team: away,
    referees,
    isHome: false,
  };

  return (
    <aside className={cn.MatchStartupFormations}>
      <Text className={cn.MatchTitle} tag="h2" color="blue" fontSize="32--34" fontWeight="500">
        {getTitle(home, away)}
      </Text>
      <MatchStartupFormation {...teamHome} />
      <MatchStartupFormation {...teamAway} />
    </aside>
  );
};

export default MatchStartupFormations;
